import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {ViaCheckApiQueryService} from './via-check-api-query.service';
import {ChileCompraDBResponse} from '../models/chilecompras-db-responses.interface';

@Injectable({
  providedIn: 'root',
})
export class ChileComprasQuerysService extends ViaCheckApiQueryService {
  public getLicitationsFromOrganism(
    pagina: number,
    organismID: number | string
  ): Observable<ChileCompraDBResponse> {
    const subdomain = `chilecompras?pagina=${pagina}&organismoID=${organismID}&isOC=false`;
    return this.networkRequest('get', subdomain);
  }

  public getLicitationsFromOrganismName(
    pagina: number,
    organismName: string
  ): Observable<ChileCompraDBResponse> {
    const subdomain = `chilecompras?pagina=${pagina}&org=${organismName}&isOC=false`;
    return this.networkRequest('get', subdomain);
  }

  public getOCFromOrganism(
    pagina: number,
    organismID: number | string
  ): Observable<ChileCompraDBResponse> {
    const subdomain = `chilecompras?pagina=${pagina}&organismoID=${organismID}&isOC=true`;
    return this.networkRequest('get', subdomain);
  }

  public getOCFromOrganismName(
    pagina: number,
    organismName: string
  ): Observable<ChileCompraDBResponse> {
    const subdomain = `chilecompras?pagina=${pagina}&org=${organismName}&isOC=true`;
    return this.networkRequest('get', subdomain);
  }

  public getSingleLicitationInfo(
    id: string
  ): Observable<ChileCompraDBResponse> {
    const subdomain = `chilecompras/${id}`;
    return this.networkRequest('get', subdomain);
  }

  public getMuniList(): Observable<ChileCompraDBResponse> {
    const subdomain = 'chilecompras?demo=muniList';
    return this.networkRequest('get', subdomain);
  }

  public getLicitationsForDemo(
    compradorNombreOrganismo: string
  ): Observable<ChileCompraDBResponse> {
    const subdomain = `chilecompras?demo=selectLicitations&org=${compradorNombreOrganismo}`;
    return this.networkRequest('get', subdomain);
  }

  public getOCForDemo(
    compradorNombreOrganismo: string
  ): Observable<ChileCompraDBResponse> {
    const subdomain = `chilecompras?demo=selectOC&org=${compradorNombreOrganismo}`;
    return this.networkRequest('get', subdomain);
  }
}
